import { render, staticRenderFns } from "./formview.vue?vue&type=template&id=64e0608d&scoped=true&"
import script from "./formview.vue?vue&type=script&lang=js&"
export * from "./formview.vue?vue&type=script&lang=js&"
import style0 from "./formview.vue?vue&type=style&index=0&id=64e0608d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0608d",
  null
  
)

export default component.exports